var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSales01(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#C2C5C5",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M16.8,18.2V9.3 M16.8,18.2V5.8c0-1,0.6-1.8,1.3-1.8h1.3c0.7,0,1.3,0.8,1.3,1.8v12.4c0,1-0.6,1.8-1.3,1.8h-1.3 C17.4,20,16.8,19.2,16.8,18.2z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#C2C5C5",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M9.8,18.2v-5.3 M9.8,18.2V9.3c0-1,0.6-1.8,1.3-1.8h1.3c0.7,0,1.3,0.8,1.3,1.8v8.9c0,1-0.6,1.8-1.3,1.8h-1.3 C10.4,20,9.8,19.2,9.8,18.2z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#0D1718",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M2.8,12.9c0-1,0.6-1.8,1.3-1.8h1.3c0.7,0,1.3,0.8,1.3,1.8v5.3c0,1-0.6,1.8-1.3,1.8H4.1c-0.7,0-1.3-0.8-1.3-1.8 V12.9z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSales01);
export default __webpack_public_path__ + "static/media/sales-01.79375c2eb146b45634498df1a006b3d5.svg";
export { ForwardRef as ReactComponent };